/**
 * Configuración del sistema de idle global
 * Lee variables de entorno y proporciona defaults seguros
 */

interface IdleConfig {
  enabled: boolean;
  idleMs: number;
  leaseMs: number;
  heartbeatMs: number;
  activityThrottleMs: number;
  channel: string;
  storageKeys: {
    lastActivity: string;
    lock: string;
    leaderHeartbeat: string;
    logout: string;
  };
}

const parseEnvBoolean = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value === undefined) return defaultValue;
  return value.toLowerCase() === 'true';
};

const parseEnvNumber = (value: string | undefined, defaultValue: number): number => {
  if (value === undefined) return defaultValue;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
};

const LEASE_MS = 10000 as const;
const HEARTBEAT_MS = 3000 as const;
const ACTIVITY_THROTTLE_MS = 800 as const;

export const idleConfig: IdleConfig = {
  // Feature flag principal - si no está en "true", todo el sistema se desactiva
  enabled: parseEnvBoolean(import.meta.env.VITE_IDLE_GLOBAL_ENABLED, false),
  
  // Tiempo de inactividad antes del logout - CONFIGURABLE VÍA ENV
  idleMs: parseEnvNumber(import.meta.env.VITE_IDLE_MS, 15 * 60 * 1000), // 15 minutos por defecto

  // Configuraciones técnicas internas - CONSTANTES (no necesitan ser configurables)
  leaseMs: LEASE_MS, // 10 segundos - duración del lease para leader election
  heartbeatMs: HEARTBEAT_MS, // 3 segundos - intervalo de heartbeat del líder
  activityThrottleMs: ACTIVITY_THROTTLE_MS, // 800ms - throttle óptimo para eventos de actividad
  
  // Canal para comunicación entre pestañas
  channel: 'igl_bus',
  
  // Claves de localStorage
  storageKeys: {
    lastActivity: 'igl_last_activity',
    lock: 'igl_lock',
    leaderHeartbeat: 'igl_leader_hb',
    logout: 'igl_logout',
  },
};

// Validaciones de configuración
if (idleConfig.enabled) {
  if (idleConfig.idleMs < 5000) {
    console.warn('[IdleGlobal] VITE_IDLE_MS muy bajo (<5s), usando 5s mínimo');
    idleConfig.idleMs = 5000;
  }

  // Validación de constantes internas (por si se modifican manualmente)
  if (idleConfig.heartbeatMs >= idleConfig.leaseMs) {
    console.warn('[IdleGlobal] heartbeat debe ser menor que lease - configuración interna incorrecta');
  }
}
